define('native/NativeMessageChannels',[],function () {
    return {
        APP_LOADED: 'appLoaded',
        LAUNCH_GAME: 'launchGame',
        LOGIN_ERROR: 'loginError',
        LOGIN_WITH_TOUCH_ID: 'loginWithTouchId',
        NOTIFICATION_ADDED: 'notificationAdded',
        OPEN_NATIVE_URL: 'openNativeUrl',
        PLAYER_LOGIN: 'playerLogin',
        PLAYER_REGISTERED: 'playerRegistered',
        REMOVE_CREDENTIALS: 'removeCredentials',
        SETUP_TOUCH_ID: 'setupTouchId'
    };
});


